import {RouteDefinition} from '../../../routes';
import {VirtualControlListScreen} from './VirtualControlListScreen';
import {VirtualControlEditScreen} from './VirtualControlEditScreen';

export const VirtualControlSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/virtual-control',
        component: VirtualControlListScreen,
    },
    {
        routerLink: '/settings/virtual-control/edit',
        component: VirtualControlEditScreen,
    },
    {
        routerLink: '/settings/virtual-control/edit/:id',
        component: VirtualControlEditScreen,
    },
];
